import React, { useMemo } from 'react';
import BaseButton from 'components/atoms/baseButton';
import EnvelopeIcon from 'components/atoms/icons/envelope';
import { useTranslation } from 'react-i18next';
import CrossIcon from 'components/atoms/icons/cross-icon';
import FadeAnimation from 'components/atoms/base-animations/fade';

import s from './styles.module.scss';

interface IProps {
  length: number;
  sendToAll: boolean;
  onClear: () => void;
  onSend: () => void;
}

const SmsCampaignsTableBulkSend: React.FC<IProps> = ({
  length,
  sendToAll,
  onClear,
  onSend,
}) => {
  const hasItems = length > 1 || sendToAll;

  if (!hasItems) return <></>;

  const { t } = useTranslation();

  const text = useMemo(() => {
    if (sendToAll) return `${t('labels.all')} ${t('labels.selected')}`;
    return `${length} ${t('labels.selected')}`;
  }, [length, sendToAll]);

  return (
    <div className={s.position}>
      <FadeAnimation className={s.animation} uniqueKey={hasItems.toString()}>
        <div className={s.wrapper}>
          <div className={s.input}>
            {text}
            <i onClick={onClear}>
              <CrossIcon />
            </i>
          </div>
          <BaseButton
            icon={<EnvelopeIcon />}
            label={t('labels.sendBulkSms')}
            width="140px"
            onClick={onSend}
          />
        </div>
      </FadeAnimation>
    </div>
  );
};

export default SmsCampaignsTableBulkSend;
